/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import { service as ProjectStatusService } from "../Services/ProjectStatusService";
import {useFilterByServiceProperty} from "./useFilterByServiceProperty";

// Hook that returns a filter function to exclude items
// based on their project status codes.
export const useFilterByProjectStatus = (projectStatusCodes) => {
    return useFilterByServiceProperty(ProjectStatusService, projectStatusCodes, 'shortName');
}
